<template src="./template.html" />
<script>

import CommentBox from 'src/modules/comments_box'
import EventBus from '@/EventBus'
import { firebase } from '@firebase/app'
const { DocumentReference } = firebase.firestore
export default {
  name: 'DetailPage',
  components: {
    CommentBox
  },
  props: {
    'title': {
      type: String,
      default: ''
    },
    'backConfirm': {
      type: Boolean,
      default: true
    },
    'backLink': {
      type: [Object, String],
      default: '/'
    },
    'scaffolding': {
      type: Object,
      default: () => {}
    },
    'queryPath': {
      type: Array,
      default: () => []
    },
    'mode': {
      type: String,
      default: undefined
    },
    'baseData': {
      type: Object,
      default: () => {}
    },
    'app': {
      type: String,
      default: null
    },
    'fetchAfterSubmit': {
      type: Boolean,
      default: false
    },
    syncData: {
      type: Boolean,
      default: false
    },
    canSave: {
      type: Boolean,
      default: true
    },
    hideBackButton: {
      type: Boolean,
      default: false
    },
    hideComment: {
      type: Boolean,
      default: false
    },
    noMinHeight: {
      type: Boolean,
      default: false
    },
    css: {
      type: String,
      default: ''
    },
    customValidate: {
      type: Function,
      default: undefined
    }
  },
  data () {
    return {
      dataPath: null,
      data: this.baseData ? this.baseData : {},
      originData: this.baseData ? this._.cloneDeep(this.baseData) : {},
      isLoading: true,
      isSubmiting: false,
      privateMode: this.mode,
      privateID: this.queryPath[1],
      confirm: false,
      formKey: 1,
      confirmLeave: false,
      errorText: null
    }
  },
  created () {
    let vm = this
    this.privateMode = !this.mode ? (this.privateID ? 'EDIT' : 'CREATE') : this.mode
    this.dataPath = this.queryPath.join('/')
  },
  async mounted () {
    this.showLoading()
    if (!this.baseData && (this.privateMode === 'EDIT' || this.privateID)) {
      await this.fetchData(this.queryPath)
    }
    this.$on('onPageUpdateScaffolding', (payload) => this.$refs.form ? this.$refs.form.$emit('onUpdateScaffolding', payload) : true)
    this.$on('onUpdateData', this.updateData)
    this.$on('onUpdateID', this.updatePrivateID)
    this.$on('onUpdateMode', this.updateMode)
    this.$on('trigger-submit', this.submitData)
    this.$emit('detail-page-fetched', this.data)
    this.isLoading = false
    this.hideLoading()
  },
  methods: {
    removeEmpty(obj) {
      let vm = this
      let cloneObj = vm._.cloneDeep(obj)
      Object.entries(cloneObj).forEach(([key, val]) => {
        if (val && typeof val === 'object' && !Array.isArray(val) && !(val instanceof DocumentReference)) {
          vm.removeEmpty(val)
        } else if (vm._.isNil(val) || (!vm._.isNumber(val) && vm._.isEmpty(val)) || val instanceof DocumentReference) {
          delete cloneObj[key]
        }
      })
      return cloneObj
    },
    onBackButtonClick() {
      if(this.backConfirm && !this._.isEqual(this.removeEmpty(this.data), this.removeEmpty(this.originData))) {
        this.confirmLeave = true
      } else {
        this.pushBack()
      }
    },
    pushBack() {
      this.$router.push(this.backLink)
    },
    async fetchData (queryPath) {
      await this.$query(queryPath, null, null, null, null, null, this.app).then(res => {
        this.data = res
        this.originData = this._.cloneDeep(this.data)
      }).catch(error => {
        this.$q.notify({
          message: `${error}`,
          color: 'red',
          icon: 'error'
        })
      })
    },
    async submitData () {
      let vm = this
      if(this.customValidate && !this.customValidate(this.data)) return
      vm.$refs.form.validate().then(async canSubmit => {
        if (canSubmit) {
          if(vm.confirmLeave) {
            await this.beginSubmit()
            this.pushBack()
          } else {
            vm.confirm = true
          }
          this.errorText = null
        } else {
          if(this.R.flatten([this.errors.items]).length > 0) {
            this.errorText = `Có lỗi ở trường "${this.R.path(['items', '0', 'field'], this.errors)}"`
            this.$q.notify({
              color: 'red',
              textColor: 'white',
              icon: 'error',
              message: this.errorText,
              position: 'top',
              multiLine: true
            })
          }
        }
      })
    },
    async beginSubmit () {
      let vm = this
      vm.isSubmiting = true
      try {
        let result = new Promise((resolve, reject) => vm.$emit('submit-event', { data: vm.data, id: vm.privateID }, resolve, reject))
        await result.then(async (res) => {
          vm.privateID = vm.privateMode === 'CREATE' || vm.privateMode === 'COPY' ? res.data.id : vm.privateID
          vm.queryPath[1] = vm.privateID
          vm.$router.push(vm.R.merge(vm.$route, { query: { id: vm.privateID } }))
          vm.$q.notify({
            message: 'Đã lưu thành công',
            color: 'black',
            icon: 'check'
          })
          vm.privateMode = 'EDIT'
          if (vm.fetchAfterSubmit) {
            vm.fetchData(vm.queryPath).then(() => {
              vm.formKey++
              vm.$emit('detail-page-fetched', vm.data)
            })
          }
        }).catch(error => {
          console.log('Detail page', error)
          vm.$q.notify({
            message: error.toString(),
            color: 'red',
            icon: 'error'
          })
        })
      } catch (error) {
        console.log(error)
        vm.$q.notify({
          message: error,
          color: 'red',
          icon: 'error'
        })
      }
      vm.isSubmiting = false
      vm.$emit('detail-page-change-mode', vm.privateMode)
    },
    showLoading () {
      if (this.$root.$children[0].$refs['top-loadding-bar']) this.$root.$children[0].$refs['top-loadding-bar'].start()
    },
    hideLoading () {
      let vm = this
      vm.$nextTick(() => {
        if (vm.$root.$children[0].$refs['top-loadding-bar']) vm.$root.$children[0].$refs['top-loadding-bar'].stop()
      })
    },
    updateData(payLoad, isMerge) {
      if(isMerge) {
        this.data = this._.merge(this.data, payLoad)
      } else {
        this.data = payLoad
      }
      this.formKey++
    },
    updatePrivateID(payLoad) {
      this.privateID = payLoad
    },
    updateMode(payLoad) {
      this.privateMode = payLoad
    }
  },
  watch: {
    data: {
      handler: function(newValue, oldValue) {
        if(this.syncData) {
          this.$emit('data-changed', this.data)
        }
      },
      deep: true
    }
  }
}
</script>
